import { ModalConfig } from './modal/modal-config'

export abstract class BaseAction {
  key: string
  name: string
  order?: number
  icon?: string
  iconType?: string
  style?: string
  // for custom type
  type?: string
  // if the action is pop a modal
  modalConfig?: ModalConfig
  constructor(options: {
    key: string
    name: string
    icon?: string
    order?: number
    style?: string
    modalConfig?: ModalConfig
  }) {
    this.key = options.key
    this.name = options.name
    this.icon = options.icon
    this.order = options.order === undefined ? 999 : options.order
    this.style = options.style
    this.modalConfig = options.modalConfig
  }
}

export interface OnAction {
  euOnAction(action: BaseAction): any
}
